module.exports = __webpack_public_path__ + "fonts/righthand-personal.2aa375d8.ttf";